import DriverChangeIcon from '@acorn-portal/shared/src/assets/shared/icons/base/circled-people.svg?react';
import { PcDriver } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';

interface IDrivers {
	drivers: PcDriver[];
	title?: string;
}

const Drivers: FC<IDrivers> = ({ drivers, title }) => {
	return (
		<Box>
			<Box sx={{ display: 'flex' }}>
				<Box sx={{ width: '65px', marginRight: '3em' }}>
					<DriverChangeIcon />
				</Box>
				<Box sx={{ flex: 1 }}>
					{title && (
						<Typography
							sx={{
								fontSize: 20,
								fontWeight: 'bold',
								textTransform: 'uppercase',
							}}
						>
							{title}
						</Typography>
					)}
					{drivers && (
						<Typography sx={{ fontSize: 16, flex: '0 0 33%' }}>
							{drivers?.map((driver, key) => (
								<span key={driver.firstName} data-testid='driver-name'>
									{driver.firstName} {driver.lastName} {key + 1 < drivers.length ? ', ' : null}
								</span>
							))}
						</Typography>
					)}
				</Box>
			</Box>
		</Box>
	);
};

export default Drivers;
